import Icon from '@/components/ui/AppIcon';

interface ContactHeroProps {
  currentLanguage: 'fr' | 'de';
}

const ContactHero = ({ currentLanguage }: ContactHeroProps) => {
  const content = {
    fr: {
      title: "Contactez-nous",
      subtitle: "Nous sommes là pour répondre à toutes vos questions et besoins de nettoyage",
      responseTime: "Réponse garantie sous 24h",
      availability: "Disponible 7j/7",
      localService: "Service local Le Locle"
    },
    de: {
      title: "Kontaktieren Sie uns",
      subtitle: "Wir sind hier, um alle Ihre Fragen und Reinigungsbedürfnisse zu beantworten",
      responseTime: "Antwort garantiert innerhalb von 24 Stunden",
      availability: "Verfügbar 7 Tage die Woche",
      localService: "Lokaler Service Le Locle"
    }
  };

  const text = content[currentLanguage];

  return (
    <section className="relative bg-gradient-to-br from-primary via-primary to-secondary py-20 lg:py-28">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-6">
            <Icon name="ChatBubbleLeftRightIcon" size={40} variant="outline" className="text-white" />
          </div>
          
          <h1 className="text-4xl lg:text-5xl font-heading font-bold text-white mb-6">
            {text.title}
          </h1>
          
          <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto">
            {text.subtitle}
          </p>
          
          <div className="flex flex-wrap justify-center gap-6 lg:gap-8">
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg">
              <Icon name="ClockIcon" size={24} variant="outline" className="text-accent" />
              <span className="text-white font-medium">{text.responseTime}</span>
            </div>
            
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg">
              <Icon name="CalendarDaysIcon" size={24} variant="outline" className="text-accent" />
              <span className="text-white font-medium">{text.availability}</span>
            </div>
            
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg">
              <Icon name="MapPinIcon" size={24} variant="outline" className="text-accent" />
              <span className="text-white font-medium">{text.localService}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;